import { Box, CircularProgress, Typography } from '@mui/material';

import { ReactComponent as ChartLineUpIcon } from 'assets/icons/ChartLineUp.svg';
import { ReactComponent as ChartLineUpIconLight } from 'assets/icons/ChartLineUpIconLight.svg';

import { useTheme } from 'themes/themeProvider';

import { useSelector } from 'react-redux';
import { userBaseCurrencySelector, userDataSelector } from 'store/slices/user-slice';
import { Currency, ThemeKey } from 'types/general.types';
import { formatCurrency } from 'utils/formatters';
import classes from './EarningsCard.module.scss';

export interface TabProp {
  label: string;
  value: string;
  date?: string;
}

type Props = {
  isLoading?: boolean;
};

const Content = ({ amount, theme, currency }: { amount: number; theme: ThemeKey; currency: Currency }) => (
  <Box display='flex' flexDirection='column' alignItems='center'>
    <Typography variant='body1' textAlign='center' marginBottom={6}>
      Estimate monthly cost
    </Typography>
    <Box display='flex' alignItems='center' mt={2}>
      {theme === ThemeKey.AMITYAGE ||
      theme === ThemeKey.BMW ||
      theme === ThemeKey.QURUBIQA ||
      theme === ThemeKey.STELLAR_FORGE ||
      theme === ThemeKey.BITCLUSTER ||
      theme === ThemeKey.DAHAB ||
      theme === ThemeKey.POLARCORE ||
      theme === ThemeKey.AVATRON ||
      theme === ThemeKey.PANTHEON ||
      theme === ThemeKey.PANTHEON_AUS ||
      theme === ThemeKey.SABRE56 ||
      theme === ThemeKey.HIGGS ||
      theme === ThemeKey.MAWSON ||
      theme === ThemeKey.REVOLVE_LABS ||
      theme === ThemeKey.EMCD ||
      theme === ThemeKey.BITASICS ||
      theme === ThemeKey.BLUEFORGE ||
      theme === ThemeKey.CRYPTOTECH ||
      theme === ThemeKey.DATACUBES ||
      theme === ThemeKey.MININGSTORE ||
      theme === ThemeKey.FORTRIS ||
      theme === ThemeKey.YMIR ||
      theme === ThemeKey.HASHLABS ||
      theme === ThemeKey.ENDLESSMINING ? (
        <ChartLineUpIconLight />
      ) : (
        <ChartLineUpIcon />
      )}
    </Box>
    <Typography variant='h3' my={2}>
      {formatCurrency(currency, amount)}
    </Typography>
  </Box>
);

export const EarningsCard = ({ isLoading }: Props) => {
  const { theme, themeKey } = useTheme();
  const baseCurrency = useSelector(userBaseCurrencySelector) ?? Currency.USD;

  const { estimatedMonthlyElectricityCost = 0 } = useSelector(userDataSelector) || {};

  return (
    <Box display='flex' flexDirection='column' alignItems='center' height='100%'>
      {isLoading ? (
        <div className={classes.loaderContainer}>
          <CircularProgress className={classes.loader} size={24} sx={{ color: theme.widgets.fiatWallet.textColor }} />
        </div>
      ) : (
        <Box display='flex' justifyContent='center' flexGrow={1} width='100%'>
          <Content amount={estimatedMonthlyElectricityCost} theme={themeKey} currency={baseCurrency} />
        </Box>
      )}
    </Box>
  );
};
